import { Vector2 } from './helpers/vector2';

/**
 * @ignore
 */
export const resolution = new Vector2(1280, 720);
